export interface ISnListResponse<Model> {
  count: number;
  results: Model[];

  // Page-based pagination
  totalPages?: number;

  // Cursor-based pagination
  next?: string;
  previous?: string;

  // Other optional fields
  facetFields?: any;
  aggregations?: any;
  groups?: any;
  skipError?: boolean;
  ordering?: any;
  links?: any;
}
